export function isDtmShop() {
  return (
    typeof window !== "undefined" &&
    window.location.host === process.env.NEXT_PUBLIC_DTM_DOMAIN
  );
}
